// This values predefined by doc
// https://setplexapps.atlassian.net/wiki/spaces/NORA/pages/3808034876/Backward+Compatibility+and+Migration
export const STATIC_IDENTIFIERS = {
  HOME: 'home',
  TV: 'tv_channels',
  VOD: 'movie',
  SHOW: 'tv_shows',
  CATCHUP: 'catchups',
  EPG: 'epg',
  EVENT: 'events',
  SEARCH: 'search',
  LIBRARY: 'library',
  SETTINGS: 'settings',
} as const
